import { Link } from 'react-router-dom';
import { Service } from '../data/services';
import { Icon } from './icons';

export type ServiceCardData = Pick<Service, 'title' | 'summary' | 'icon' | 'accent'> & {
  /** Where the card links. Defaults to /services/:slug for catalogue services. */
  to?: string;
  slug?: string;
};

interface ServiceCardProps {
  service: ServiceCardData;
}

const isProductIcon = (icon: string) => icon.startsWith('ms-');

function ServiceCard({ service }: ServiceCardProps) {
  const to = service.to ?? `/services/${service.slug}`;

  return (
    <Link to={to} className="service-card service-card-link">
      {isProductIcon(service.icon) ? (
        <div className="service-icon-product">
          <Icon id={service.icon} size={36} />
        </div>
      ) : (
        <div className={`service-icon service-icon-${service.accent}`}>
          <Icon id={service.icon} size={28} />
        </div>
      )}
      <h3 className="service-title">{service.title}</h3>
      <p className="service-description">{service.summary}</p>
      <span className="service-card-arrow">Learn more &rarr;</span>
    </Link>
  );
}

export default ServiceCard;
